import { render, staticRenderFns } from "./StructuresChanged.vue?vue&type=template&id=2abc9119&"
import script from "./StructuresChanged.vue?vue&type=script&lang=js&"
export * from "./StructuresChanged.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports